<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">校区成绩锁定列表</span>
                <div v-loading="loading">
                  <el-row class="cs-search-conditions margin-top-10" :gutter="20">
                    <el-col :span="4">
                      <el-select placeholder="学期" size="medium" :disabled="loading" v-model="termId" @change="onTermIdChange">
                        <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
                      </el-select>
                    </el-col>
                    <!-- <el-col :span="8">
                      当前学期:{{ currentTermDesc }}
                    </el-col> -->
                    <el-col :offset="4" :span="12" class="text-left">
                      <el-button @click="onSave()" :disabled="loading" type="primary" class="" size="medium">
                        保存
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-row class="grid-content">
                    <el-col>
                      <el-row v-for="item in scoreLocks" :key="item.UniversityGroup">
                        <el-col :span="8">{{item.UniversityGroupName}}:</el-col>
                        <el-col :span="4">
                          <el-checkbox v-model="item.IsLocked"></el-checkbox>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.grid-content {
  margin-top: 1rem;
}
</style>

<script>
import navigator from "../../components/navigator";
import {
  getTerms,
  getCurrentTerm
} from "../../service/common.service";
import {
  getUniversityScoreLocks,
  saveUniversityScoreLocks,
} from "../../service/signInManage.service";

export default {
  data() {
    return {
      isReadonly: false,
      loading: false,
      currentTermDesc: "",
      scoreLocks: [],
      termId: "",
      termList: [],
    };
  },
  components: {
    navigator,
  },
  created() {
    this.init();
    // getCurrentTerm().then(result => {
    //   if (!!result && result.success) {
    //     this.currentTermDesc = result.data.Description;
    //   }
    // });
    
  },
  methods: {
    async init(){
      await this.loadTermsFromServer();
      this.loadScoreLocks();
    },
    onTermIdChange(){
      this.loadScoreLocks();
    },
    async loadTermsFromServer() {
      this.loading = true;
      try {
        let result = await getTerms(false, true);
        this.termList = !!result && result.success ? result.data : [];
        let currentTerm = null;
        if (this.termList.length > 0) {
          currentTerm = this.termList.find((i) => i.IsCurrentTerm);
          if (!currentTerm) currentTerm = this.termList[0];
        }
        this.termId = !!currentTerm ? currentTerm.Id : null;
      } catch (error) {
        console.error(error);
      }
    },
    loadScoreLocks() {
      this.loading = true;
      getUniversityScoreLocks(this.termId).then(result => {
        if (result && result.success) {
          this.scoreLocks = result.data;
        } else {
          if (!!result.message) {
            this.$message({
              message: result.message,
              type: 'error'
            });
          }
        }
        this.loading = false;
      });
    },
    onSave() {
      this.loading = true;
      saveUniversityScoreLocks(this.termId, this.scoreLocks).then(result => {
        if (result && result.success) {
          this.$message.success("保存成功");
        } else {
          let message = result.message;
          if (!message) {
            message = "保存失败";
          }
          this.$message.error(message);
        }
        this.loading = false;
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/page/admin/universityScoreLockList.vue